import React, { ReactElement } from 'react';
import TableCell from '../table-cell/table-cell.component';
import FormatService from '../../services/format-service';
import useStylesTableCellExtended from './table-cell-extended.styles';

const TableCellExtended: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isText,
    isLarge,
    isEditMode,
    isSticky,
    isStickyLeft,
    isStickyLeftSelectExtended,
    children,
  } = props;

  const { classes } = useStylesTableCellExtended();

  const editClassName: string | undefined = isEditMode ? classes.tableCellExtendedEdit : undefined;
  const largeClassName: string | undefined = isLarge ? classes.tableCellExtendedLarge : undefined;

  return (
    <TableCell
      isText={isText}
      isSticky={isSticky}
      isStickyLeft={isStickyLeft}
      isStickyLeftSelectExtended={isStickyLeftSelectExtended}
      className={FormatService.formatClassNames(classes.tableCellExtended, editClassName, largeClassName)}
    >
      {children}
    </TableCell>
  );
});

export default TableCellExtended;
